import React, { memo } from 'react'
import { Maybe } from 'types/graphqlTypes'
import { useUserDetails } from 'utils/hooks'
import { ILatestBidApprovalFragment } from '../../graphql/LatestBidApprovalFragment'
import OptionActionsButtonGroup from './OptionActionsButtonGroup'
import { IOptionActionsButtonGroupProps } from './OptionActionsButtonGroup/OptionActionsButtonGroup'
import OptionReviewButtonGroup from './OptionReviewButtonGroup'
import { TEST_IDS } from './constants'

export interface ICarrierOptionButtonsProps extends Pick<IOptionActionsButtonGroupProps, 'option'> {
  bidApproval: Maybe<ILatestBidApprovalFragment>
}

const CarrierOptionButtons = memo<ICarrierOptionButtonsProps>(({ bidApproval, option }) => {
  const { userPermissions } = useUserDetails()
  const { canUpdateBidApprovalState } = userPermissions || {}

  const showBidApprovalReviewButtons = canUpdateBidApprovalState && bidApproval

  return (
    <div>
      {showBidApprovalReviewButtons && (
        <div data-test={TEST_IDS.optionReviewButtonGroup}>
          <hr />
          <OptionReviewButtonGroup bidApproval={bidApproval} />
        </div>
      )}
      {!canUpdateBidApprovalState && (
        <div data-test={TEST_IDS.optionActionsButtonGroup}>
          <hr />
          <OptionActionsButtonGroup option={option} bidApproval={bidApproval} />
        </div>
      )}
    </div>
  )
})

export default CarrierOptionButtons
